/**
 * Public Page navigation (shared)
 *
 */
export const publicNav = [
    {
        title: 'Substrates',
        slug: 'nav-public-substrates',
        route: '/x/substrates',
        substrateClass: 'connect',
        icon: '',
    },
    {
        title: 'Innovation Activities',
        slug: 'nav-public-use-cases',
        route: '/x/use-cases',
        substrateClass: 'connect',
        icon: '',
    },
    {
        title: 'Book A Call',
        slug: 'nav-public-book-call',
        func: 'openHelpWidget',
        route: '/',
        substrateClass: 'connect',
        icon: '',
    },
];
